import produce from 'immer';
import { isError } from 'lodash';
import {
  StatusListaAPIEnum,
  StatusListaRPAEnum,
  UploadeProgressEnum,
} from '../../enums';
import history from '../../services/history';
import { getDifferenceBetween } from '../../utils/array';
import {
  setTabContentPorStatus,
  setTabContentPorStatusSingleObj,
  setTabContentSingleObj,
} from '../../utils/setTabContentPorStatus';

export const Types = {
  DELETE_LISTA_CSV_REQUEST: '@lista/DELETE_LISTA_CSV_REQUEST',
  GET_ARQUIVO_LOTE_ORIGINAL_REQUEST: '@lista/GET_ARQUIVO_LOTE_ORIGINAL_REQUEST',
  GET_ARQUIVO_LOTE_ORIGINAL_SUCCESS: '@lista/GET_ARQUIVO_LOTE_ORIGINAL_SUCCESS',
  GET_ARQUIVO_LOTE_ORIGINAL_ERROR: '@lista/GET_ARQUIVO_LOTE_ORIGINAL_ERROR',
  GET_ARQUIVO_LOTE_ORIGINAL_RENEW: '@lista/GET_ARQUIVO_LOTE_ORIGINAL_RENEW',
  POST_IMPORTAR_LOTE_CSV_REQUEST: '@lista/POST_IMPORTAR_LOTE_CSV_REQUEST',
  POST_IMPORTAR_LOTE_CSV_SUCCESS: '@lista/POST_IMPORTAR_LOTE_CSV_SUCCESS',
  POST_VALIDAR_LOTE_CSV_REQUEST: '@lista/POST_VALIDAR_LOTE_CSV_REQUEST',
  POST_RELATORIO_RESUMIDO_NOVO_REQUEST:
    '@lista/POST_RELATORIO_RESUMIDO_NOVO_REQUEST',
  POST_RELATORIO_RESUMIDO_NOVO_SUCCESS:
    '@lista/POST_RELATORIO_RESUMIDO_NOVO_SUCCESS',
  POST_RELATORIO_RESUMIDO_NOVO_ERROR:
    '@lista/POST_RELATORIO_RESUMIDO_NOVO_ERROR',
  POST_RELATORIO_RESUMIDO_NOVO_RENEW:
    '@lista/POST_RELATORIO_RESUMIDO_NOVO_RENEW',
  POST_RELATORIO_DETALHADO_NOVO_REQUEST:
    '@lista/POST_RELATORIO_DETALHADO_NOVO_REQUEST',
  POST_RELATORIO_DETALHADO_NOVO_SUCCESS:
    '@lista/POST_RELATORIO_DETALHADO_NOVO_SUCCESS',
  POST_RELATORIO_DETALHADO_NOVO_ERROR:
    '@lista/POST_RELATORIO_DETALHADO_NOVO_ERROR',
  POST_RELATORIO_DETALHADO_NOVO_RENEW:
    '@lista/POST_RELATORIO_DETALHADO_NOVO_RENEW',
  POST_SEARCH_LIST_RPA_REQUEST: '@lista/POST_SEARCH_LIST_RPA_REQUEST',
  POST_SEARCH_LIST_RPA_RESPONSE: '@lista/POST_SEARCH_LIST_RPA_RESPONSE',
  GET_STATUS_LIST_RPA_REQUEST: '@lista/GET_STATUS_LIST_RPA_REQUEST',
  GET_STATUS_LIST_RPA_RESPONSE: '@lista/GET_STATUS_LIST_RPA_RESPONSE',
  POST_SEARCH_LIST_REQUEST: '@lista/POST_SEARCH_LIST_REQUEST',
  POST_SEARCH_LIST_RESPONSE: '@lista/POST_SEARCH_LIST_RESPONSE',
  GET_STATUS_LIST_CONTRATANTE_REQUEST:
    '@lista/GET_STATUS_LIST_CONTRATANTE_REQUEST',
  GET_STATUS_LIST_CONTRATANTE_RESPONSE:
    '@lista/GET_STATUS_LIST_CONTRATANTE_RESPONSE',
  GET_STATUS_LIST_ADMIN_REQUEST: '@lista/GET_STATUS_LIST_ADMIN_REQUEST',
  GET_STATUS_LIST_ADMIN_RESPONSE: '@lista/GET_STATUS_LIST_ADMIN_RESPONSE',
  GET_STATUS_LIST_NESTLE_REQUEST: '@lista/GET_STATUS_LIST_NESTLE_REQUEST',
  GET_STATUS_LIST_NESTLE_RESPONSE: '@lista/GET_STATUS_LIST_NESTLE_RESPONSE',
  POST_LISTA_INATIVAS_REQUEST: '@lista/POST_LISTA_INATIVAS_REQUEST',
  POST_LISTA_INATIVAS_RESPONSE: '@lista/POST_LISTA_INATIVAS_RESPONSE',
  PUT_LISTA_INATIVAS_REQUEST: '@lista/PUT_LISTA_INATIVAS_REQUEST',
  PUT_LISTA_INATIVAS_RESPONSE: '@lista/PUT_LISTA_INATIVAS_RESPONSE',
  GET_LISTA_INATIVAS_REQUEST: '@lista/GET_LISTA_INATIVAS_REQUEST',
  GET_LISTA_INATIVAS_RESPONSE: '@lista/GET_LISTA_INATIVAS_RESPONSE',
  GET_LISTA_BENEFICIARIOS_RENEW: '@lista/GET_LISTA_BENEFICIARIOS_RENEW',
  GET_LISTA_BENEFICIARIOS_REQUEST: '@lista/GET_LISTA_BENEFICIARIOS_REQUEST',
  GET_LISTA_BENEFICIARIOS_RESPONSE: '@lista/GET_LISTA_BENEFICIARIOS_RESPONSE',
  GET_GRUPO_FAMILIAR_REQUEST: '@lista/GET_GRUPO_FAMILIAR_REQUEST',
  GET_GRUPO_FAMILIAR_RESPONSE: '@lista/GET_GRUPO_FAMILIAR_RESPONSE',
  POST_SALVAR_BENEFICIARIO_INATIVOS_REQUEST:
    '@lista/POST_SALVAR_BENEFICIARIO_INATIVOS_REQUEST',
  POST_SALVAR_BENEFICIARIO_INATIVOS_SUCCESS:
    '@lista/POST_SALVAR_BENEFICIARIO_INATIVOS_SUCCESS',
  POST_SALVAR_BENEFICIARIO_INATIVOS_ERROR:
    '@lista/POST_SALVAR_BENEFICIARIO_INATIVOS_ERROR',
  CHECK_BENEFICIARIO_INATIVOS: '@lista/CHECK_BENEFICIARIO_INATIVOS',
  SET_BENEFICIARIOS_SUCCESS: '@lista/SET_BENEFICIARIOS_SUCCESS',
  SET_LISTA_FAMILIAR_REQUEST: '@lista/SET_LISTA_FAMILIAR_REQUEST',
  POST_LISTA_FAMILIAR_REQUEST: '@lista/POST_LISTA_FAMILIAR_REQUEST',
  POST_LISTA_FAMILIAR_RESPONSE: '@lista/POST_LISTA_FAMILIAR_RESPONSE',
  GET_RELATORIO_RPA_REQUEST: '@lista/GET_RELATORIO_RPA_REQUEST',
  GET_RELATORIO_RPA_SUCCESS: '@lista/GET_RELATORIO_RPA_SUCCESS',
  GET_RELATORIO_RPA_ERROR: '@lista/GET_RELATORIO_RPA_ERROR',
  GET_RELATORIO_RPA_RENEW: '@lista/GET_RELATORIO_RPA_RENEW',
  GET_LISTAS_REQUEST: '@lista/GET_LISTAS_REQUEST',
  GET_LISTAS_SUCCESS: '@lista/GET_LISTAS_SUCCESS',
  GET_LISTAS_ERROR: '@lista/GET_LISTAS_ERROR',
  GET_LISTAS_POR_STATUS_REQUEST: '@lista/GET_LISTAS_POR_STATUS_REQUEST',
  GET_LISTAS_POR_STATUS_SUCCESS: '@lista/GET_LISTAS_POR_STATUS_SUCCESS',
  GET_LISTAS_POR_STATUS_ERROR: '@lista/GET_LISTAS_POR_STATUS_ERROR',
  GET_LISTAS_RPA_REQUEST: '@listasRPA/GET_LISTAS_RPA_REQUEST',
  GET_LISTAS_RPA_SUCCESS: '@listasRPA/GET_LISTAS_RPA_SUCCESS',
  GET_LISTAS_RPA_ERROR: '@listasRPA/GET_LISTAS_ERROR',
  GET_LISTA_DETALHE_REQUEST: '@listas/GET_LISTA_DETALHE_REQUEST',
  GET_LISTA_DETALHE_SUCCESS: '@listas/GET_LISTA_DETALHE_SUCCESS',
  GET_LISTA_DETALHE_ERROR: '@listas/GET_LISTA_DETALHE_ERROR',
  GET_LISTA_MASSA_INICIAL_REQUEST:
    '@listasMassaInicial/GET_LISTAS_MASSA_INICIAL_REQUEST',
  GET_LISTA_MASSA_INICIAL_ERROR:
    '@listasMassaInicial/GET_LISTAS_MASSA_INICIAL_ERROR',
  GET_LISTA_MASSA_INICIAL_SUCCESS:
    '@listasMassaInicial/GET_LISTAS_MASSA_INICIAL_SUCCESS',
  GET_ARQUIVO_MASSA_INICIAL_REQUEST:
    '@listasMassaInicial/GET_ARQUIVO_MASSA_INICIAL_REQUEST',
  GET_ARQUIVO_MASSA_INICIAL_ERROR:
    '@listasMassaInicial/GET_ARQUIVO_MASSA_INICIAL_ERROR',
  GET_ARQUIVO_MASSA_INICIAL_SUCCESS:
    '@listasMassaInicial/GET_ARQUIVO_MASSA_INICIAL_SUCCESS',
  GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_REQUEST:
    '@listasMassaInicial/GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_REQUEST',
  GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_ERROR:
    '@listasMassaInicial/GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_ERROR',
  GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_SUCCESS:
    '@listasMassaInicial/GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_SUCCESS',
  POST_ARQUIVO_MASSA_INICIAL_REQUEST:
    '@lista/POST_ARQUIVO_MASSA_INICIAL_REQUEST',
  POST_ARQUIVO_MASSA_INICIAL_SUCCESS:
    '@lista/POST_ARQUIVO_MASSA_INICIAL_SUCCESS',
  POST_ARQUIVO_MASSA_INICIAL_ERROR: '@lista/POST_ARQUIVO_MASSA_INICIAL_ERROR',
  POST_ARQUIVO_MASSA_INICIAL_RENEW: '@lista/POST_ARQUIVO_MASSA_INICIAL_RENEW',
  PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_REQUEST:
    '@lista/PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_REQUEST',
  PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_SUCCESS:
    '@lista/PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_SUCCESS',
  PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_ERROR:
    '@lista/PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_ERROR',
  PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_RENEW:
    '@lista/PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_RENEW',
  GET_LISTAS_RPA_POR_STATUS_REQUEST: '@lista/GET_LISTAS_RPA_POR_STATUS_REQUEST',
  GET_LISTAS_RPA_POR_STATUS_SUCCESS: '@lista/GET_LISTAS_RPA_POR_STATUS_SUCCESS',
  GET_LISTAS_RPA_POR_STATUS_ERROR: '@lista/GET_LISTAS_RPA_POR_STATUS_ERROR',
  POST_ARQUIVO_IMPORTACAO_REQUEST: '@lista/POST_ARQUIVO_IMPORTACAO_REQUEST',
  POST_ARQUIVO_IMPORTACAO_SUCCESS: '@lista/POST_ARQUIVO_IMPORTACAO_SUCCESS',
  POST_ARQUIVO_IMPORTACAO_ERROR: '@lista/POST_ARQUIVO_IMPORTACAO_ERROR',
  IMPORTAR_LOTE_REQUEST: '@lista/IMPORTAR_LOTE_REQUEST',
  IMPORTAR_LOTE_RENEW: '@lista/IMPORTAR_LOTE_RENEW',
  IMPORTAR_LOTE_UPDATE: '@lista/IMPORTAR_LOTE_UPDATE',
  IMPORTAR_LOTE_UPDATE_PROGRESS: '@lista/IMPORTAR_LOTE_UPDATE_PROGRESS',
  IMPORTAR_LOTE_UPDATE_STATUS: '@lista/IMPORTAR_LOTE_UPDATE_STATUS',
  IMPORTAR_LOTE_UPDATE_FILES: '@lista/IMPORTAR_LOTE_UPDATE_FILES',
  IMPORTAR_LOTE_SUCCESS: '@lista/IMPORTAR_LOTE_SUCCESS',
  IMPORTAR_LOTE_LOG_ERROR: '@lista/IMPORTAR_LOTE_LOG_ERROR',
  IMPORTAR_LOTE_LOG_ERROR_RENEW: '@lista/IMPORTAR_LOTE_LOG_ERROR_RENEW',
  IMPORTAR_LOTE_ERROR: '@lista/IMPORTAR_LOTE_ERROR',
  IMPORTAR_LOTE_NESTLE_REQUEST: '@lista/IMPORTAR_LOTE_NESTLE_REQUEST',
  PUT_LISTAS_REQUEST: '@lista/PUT_LISTAS_REQUEST',
  PUT_LISTAS_RENEW: '@lista/PUT_LISTAS_RENEW',
  PUT_LISTAS_SUCCESS: '@lista/PUT_LISTAS_SUCCESS',
  PUT_LISTAS_ERROR: '@lista/PUT_LISTAS_ERROR',
  PATCH_LISTA_STATUS_REQUEST: '@lista/PATCH_LISTA_STATUS_REQUEST',
  PATCH_LISTA_STATUS_RENEW: '@lista/PATCH_LISTA_STATUS_RENEW',
  PACTH_LISTA_STATUS_SUCCESS: '@lista/PACTH_LISTA_STATUS_SUCCESS',
  PATCH_LISTA_STATUS_ERROR: '@lista/PATCH_LISTA_STATUS_ERROR',
  PATCH_LISTA_ENVIO_RPA_REQUEST: '@lista/PATCH_LISTA_ENVIO_RPA_REQUEST',
  PATCH_LISTA_ENVIO_RPA_SUCCESS: '@lista/PATCH_LISTA_ENVIO_RPA_SUCCESS',
  PATCH_LISTA_ENVIO_RPA_ERROR: '@lista/PATCH_LISTA_ENVIO_RPA_ERROR',
  PATCH_LISTA_ENVIO_RPA_RENEW: '@lista/PATCH_LISTA_ENVIO_RPA_RENEW',
  PATCH_STATUS_RPA_REQUEST: '@listasRPA/PATCH_STATUS_RPA_REQUEST',
  PATCH_STATUS_RPA_SUCCESS: '@listasRPA/PATCH_STATUS_RPA_SUCCESS',
  PATCH_STATUS_RPA_ERROR: '@listasRPA/PATCH_STATUS_RPA_ERROR',
  PATCH_STATUS_RPA_RENEW: '@listasRPA/PATCH_STATUS_RPA_RENEW',
  DELETE_LISTA_REQUEST: '@lista/DELETE_LISTA_REQUEST',
  DELETE_LISTA_SUCCESS: '@lista/DELETE_LISTA_SUCCESS',
  DELETE_LISTA_RENEW: '@lista/DELETE_LISTA_RENEW',
  DELETE_LISTA_ERROR: '@lista/DELETE_LISTA_ERROR',
  PATCH_VALIDACAO_LISTA_TRASNFERENCIA_REQUEST:
    '@lista/PATCH_VALIDACAO_LISTA_TRASNFERENCIA_REQUEST',
  PATCH_VALIDACAO_LISTA_TRASNFERENCIA_SUCCESS:
    '@lista/PATCH_VALIDACAO_LISTA_TRASNFERENCIA_SUCCESS',
  PATCH_VALIDACAO_LISTA_TRASNFERENCIA_ERROR:
    '@lista/PATCH_VALIDACAO_LISTA_TRASNFERENCIA_ERROR',
  PATCH_VALIDACAO_LISTA_TRASNFERENCIA_RENEW:
    '@lista/PATCH_VALIDACAO_LISTA_TRASNFERENCIA_RENEW',
};

const INITIAL_STATE = {
  loading: false,
  uploadLoading: false,
  getRelatorioLista: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getArquivoOriginalLote: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  listas: {
    loading: false,
    success: false,
    response: {
      totalCount: 0,
      totalPages: 0,
      pageNumber: 0,
      pageSize: 0,
      data: [],
    },
  },
  listasRpa: {
    loading: false,
    success: false,
    response: {
      totalCount: 0,
      totalPages: 0,
      pageNumber: 0,
      pageSize: 0,
      data: [],
    },
  },
  error: null,
  response: [],
  beneficiario: [],
  statusLists: {
    loading: false,
    success: false,
    response: {
      availables: [],
      actives: [],
    },
  },
  postSalvarBeneficiarioInativos: {
    data: [],
    success: false,
    isError: false,
    loading: false,
    error: null,
  },
  postPesquisaBeneficiario: {
    data: [],
    success: false,
    isError: false,
    loading: false,
  },
  grupoFamiliar: [],
  loadFamiliar: false,
  success: false,
  isError: false,
  details: false,
  create: false,
  putListas: {
    success: false,
    isError: false,
    response: [],
    loading: false,
  },
  patchListaStatus: {
    success: false,
    isError: false,
    response: [],
    loading: false,
  },
  postArquivoImportacao: {
    success: false,
    isError: false,
    response: [],
    loading: false,
  },
  unsuccessResponse: '',
  // success: false,
  postImportarLoteCsv: {
    loading: false,
    success: false,
  },
  postImportarLote: {
    loading: false,
    tipoMovimentacao: '',
    files: [],
    success: false,
    isPartialSuccess: false,
    isError: false,
    error: '',
    logError: [],
  },
  getListas: {
    loading: false,
    success: false,
    response: {
      Todas: { data: [], size: 0 },
      Processada: { data: [], size: 0 },
      Registrada: { data: [], size: 0 },
      Pendente: { data: [], size: 0 },
      EmValidacao: { data: [], size: 0 },
      EmEspera: { data: [], size: 0 },
      ComErro: { data: [], size: 0 },
      Excluida: { data: [], size: 0 },
    },
    unsuccessResponse: [],
    error: null,
  },
  deleteLista: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  patchListaEnvioRPA: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getListasRPA: {
    loading: false,
    success: false,
    response: {
      Todas: { data: [], size: 0 },
      Processar: { data: [], size: 0 },
      Reprocessar: { data: [], size: 0 },
      Liberar: { data: [], size: 0 },
      Alteracao: { data: [], size: 0 },
      PreVenda: { data: [], size: 0 },
      Importacao: { data: [], size: 0 },
      ComErros: { data: [], size: 0 },
    },
    unsuccessResponse: [],
    error: null,
  },
  patchStatusRPA: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  postListaTransferencia: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getRelatorioRPA: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getListaDetalhe: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  patchValidacaoListaTransferencia: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getListaMassaInicial: {
    loading: false,
    success: false,
    response: {
      Todas: {
        data: [],
        size: 0,
      },
    },
    error: null,
  },
  getArquivoMassaInicial: {
    loading: false,
    success: false,
    response: {},
    error: null,
  },
  MassaInicial: {
    post: {
      loading: false,
      success: false,
      error: null,
      isError: false,
      idLista: null,
    },
    patch: {
      loading: false,
      success: false,
      error: null,
      isError: false,
    },
  },
};

export default function lista(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_ARQUIVO_LOTE_ORIGINAL_REQUEST: {
        draft.getArquivoOriginalLote.loading = true;
        break;
      }
      case Types.GET_ARQUIVO_LOTE_ORIGINAL_RENEW: {
        draft.getArquivoOriginalLote.loading = false;
        draft.getArquivoOriginalLote.success = false;
        draft.getArquivoOriginalLote.response = {};
        draft.getArquivoOriginalLote.unsuccessResponse = [];
        draft.getArquivoOriginalLote.error = null;
        draft.getArquivoOriginalLote.isError = false;
        break;
      }
      case Types.GET_ARQUIVO_LOTE_ORIGINAL_SUCCESS: {
        draft.getArquivoOriginalLote.loading = false;
        draft.getArquivoOriginalLote.response = action.payload.response;
        draft.getArquivoOriginalLote.success = action.payload.success;
        break;
      }
      case Types.GET_ARQUIVO_LOTE_ORIGINAL_ERROR: {
        draft.getArquivoOriginalLote.loading = false;
        draft.getArquivoOriginalLote.isError = true;
        draft.getArquivoOriginalLote.error = action.payload.error;
        break;
      }
      case Types.POST_RELATORIO_RESUMIDO_NOVO_REQUEST: {
        draft.getRelatorioLista.loading = true;
        break;
      }
      case Types.POST_RELATORIO_RESUMIDO_NOVO_RENEW: {
        draft.getRelatorioLista.loading = false;
        draft.getRelatorioLista.success = false;
        draft.getRelatorioLista.response = {};
        draft.getRelatorioLista.unsuccessResponse = [];
        draft.getRelatorioLista.error = null;
        draft.getRelatorioLista.isError = false;
        break;
      }
      case Types.POST_RELATORIO_RESUMIDO_NOVO_SUCCESS: {
        draft.getRelatorioLista.loading = false;
        draft.getRelatorioLista.response = action.payload.response;
        draft.getRelatorioLista.success = action.payload.success;
        break;
      }
      case Types.POST_RELATORIO_RESUMIDO_NOVO_ERROR: {
        draft.getRelatorioLista.loading = false;
        draft.getRelatorioLista.isError = true;
        draft.getRelatorioLista.error = action.payload.error;
        break;
      }
      case Types.POST_RELATORIO_DETALHADO_NOVO_REQUEST: {
        draft.getRelatorioLista.loading = true;
        break;
      }
      case Types.POST_RELATORIO_DETALHADO_NOVO_RENEW: {
        draft.getRelatorioLista.loading = false;
        draft.getRelatorioLista.success = false;
        draft.getRelatorioLista.response = {};
        draft.getRelatorioLista.unsuccessResponse = [];
        draft.getRelatorioLista.error = null;
        draft.getRelatorioLista.isError = false;
        break;
      }
      case Types.POST_RELATORIO_DETALHADO_NOVO_SUCCESS: {
        draft.getRelatorioLista.loading = false;
        draft.getRelatorioLista.response = action.payload.response;
        draft.getRelatorioLista.success = action.payload.success;
        break;
      }
      case Types.POST_RELATORIO_DETALHADO_NOVO_ERROR: {
        draft.getRelatorioLista.loading = false;
        draft.getRelatorioLista.isError = true;
        draft.getRelatorioLista.error = action.payload.error;
        break;
      }
      case Types.POST_SEARCH_LIST_RPA_REQUEST: {
        draft.listasRpa.loading = true;
        draft.listasRpa.success = false;
        break;
      }
      case Types.POST_SEARCH_LIST_RPA_RESPONSE: {
        draft.listasRpa.loading = false;
        draft.listasRpa.success = true;
        draft.listasRpa.response = action.payload.response;
        break;
      }
      case Types.POST_SEARCH_LIST_REQUEST: {
        draft.listas.loading = true;
        draft.listas.success = false;
        break;
      }
      case Types.POST_SEARCH_LIST_RESPONSE: {
        draft.listas.loading = false;
        draft.listas.success = true;
        draft.listas.response = action.payload.response;
        break;
      }
      case Types.GET_STATUS_LIST_CONTRATANTE_REQUEST: {
        draft.statusLists.loading = true;
        draft.statusLists.success = false;
        break;
      }
      case Types.GET_STATUS_LIST_ADMIN_REQUEST: {
        draft.statusLists.loading = true;
        draft.statusLists.success = false;
        break;
      }
      case Types.GET_STATUS_LIST_RPA_REQUEST: {
        draft.statusLists.loading = true;
        draft.statusLists.success = false;
        break;
      }
      case Types.GET_STATUS_LIST_RPA_RESPONSE: {
        draft.statusLists.loading = false;
        draft.statusLists.success = true;
        draft.statusLists.response = action.payload.response;
        break;
      }
      case Types.GET_STATUS_LIST_CONTRATANTE_RESPONSE: {
        draft.statusLists.loading = false;
        draft.statusLists.success = true;
        draft.statusLists.response = action.payload.response;
        break;
      }
      case Types.GET_STATUS_LIST_ADMIN_RESPONSE: {
        draft.statusLists.loading = false;
        draft.statusLists.success = true;
        draft.statusLists.response = action.payload.response;
        break;
      }
      case Types.GET_STATUS_LIST_NESTLE_REQUEST: {
        draft.statusLists.loading = true;
        draft.statusLists.success = false;
        break;
      }
      case Types.GET_STATUS_LIST_NESTLE_RESPONSE: {
        draft.statusLists.loading = false;
        draft.statusLists.success = true;
        draft.statusLists.response = action.payload.response;
        break;
      }
      case Types.GET_LISTAS_REQUEST: {
        draft.getListas.loading = true;
        break;
      }
      case Types.GET_LISTAS_SUCCESS: {
        draft.getListas.loading = false;
        setTabContentPorStatus(
          action.payload.response,
          StatusListaAPIEnum.returnTabForName,
          draft.getListas.response
        );

        draft.getListas.success = action.payload.success;
        break;
      }
      case Types.POST_LISTA_INATIVAS_REQUEST: {
        draft.loading = true;
        draft.success = false;
        draft.isError = false;
        draft.error = false;
        draft.response = [];

        break;
      }
      case Types.POST_LISTA_INATIVAS_RESPONSE: {
        draft.loading = false;
        draft.create = true;
        draft.success = true;
        draft.isError = action.payload.isError;
        draft.response = action.payload.response;

        break;
      }
      case Types.PUT_LISTA_INATIVAS_REQUEST: {
        draft.loading = true;
        draft.success = false;
        draft.isError = false;
        draft.error = false;
        draft.details = true;
        draft.response = [];

        break;
      }
      case Types.PUT_LISTA_INATIVAS_RESPONSE: {
        draft.loading = false;
        draft.success = true;
        draft.isError = action.payload.isError;
        draft.response = action.payload.response;
        break;
      }
      case Types.GET_LISTA_BENEFICIARIOS_RESPONSE: {
        draft.postPesquisaBeneficiario = action.payload.response;
        draft.postPesquisaBeneficiario.loading = false;
        draft.postPesquisaBeneficiario.success = action.payload.success;
        break;
      }
      case Types.GET_LISTA_BENEFICIARIOS_RENEW: {
        draft.postPesquisaBeneficiario = {
          data: [],
          success: false,
          isError: false,
          loading: false,
        };
        break;
      }
      case Types.GET_LISTA_BENEFICIARIOS_REQUEST: {
        draft.postPesquisaBeneficiario = { data: [] };
        draft.postPesquisaBeneficiario.loading = true;
        draft.postPesquisaBeneficiario.success = false;
        break;
      }

      case Types.POST_SALVAR_BENEFICIARIO_INATIVOS_REQUEST: {
        draft.postSalvarBeneficiarioInativos.loading = true;
        draft.postSalvarBeneficiarioInativos.success = false;
        draft.postSalvarBeneficiarioInativos.loadFamiliar = false;
        draft.postSalvarBeneficiarioInativos.data = {};
        break;
      }
      case Types.POST_SALVAR_BENEFICIARIO_INATIVOS_SUCCESS: {
        draft.postSalvarBeneficiarioInativos.loading = false;
        draft.postSalvarBeneficiarioInativos.success = action.payload.success;
        draft.postSalvarBeneficiarioInativos.loadFamiliar = false;
        draft.postSalvarBeneficiarioInativos.data = action.payload.response;

        draft.loading = false;
        draft.success = true;
        draft.loadFamiliar = true;
        draft.beneficiario = action.payload.response;
        break;
      }
      case Types.POST_SALVAR_BENEFICIARIO_INATIVOS_ERROR: {
        draft.postSalvarBeneficiarioInativos.loading = false;
        draft.postSalvarBeneficiarioInativos.success = false;
        draft.postSalvarBeneficiarioInativos.loadFamiliar = false;
        draft.loading = false;
        draft.success = false;
        draft.loadFamiliar = false;
        draft.beneficiario = [];
        break;
      }
      case Types.CHECK_BENEFICIARIO_INATIVOS: {
        draft.response.listaGrupoFamiliar =
          draft.response?.listaGrupoFamiliar.map((beneficiario) =>
            beneficiario?.grau === 'DEPENDENTE' &&
            beneficiario?.idBeneficiario === action.payload.idBeneficiario
              ? { ...beneficiario, isChecked: !beneficiario.isChecked }
              : beneficiario
          );
        break;
      }
      case Types.POST_LISTA_FAMILIAR_REQUEST: {
        draft.postSalvarBeneficiarioInativos.loading = true;
        draft.postSalvarBeneficiarioInativos.success = false;
        draft.postSalvarBeneficiarioInativos.error = null;
        break;
      }
      case Types.POST_LISTA_FAMILIAR_RESPONSE: {
        draft.postSalvarBeneficiarioInativos.loading = false;
        draft.postSalvarBeneficiarioInativos.success = action.payload.success;
        draft.postSalvarBeneficiarioInativos.error = action.payload.error;
        draft.postSalvarBeneficiarioInativos.data = action.payload.response;
        break;
      }
      case Types.SET_LISTA_FAMILIAR_REQUEST: {
        draft.grupoFamiliar = action.payload.param;
        break;
      }
      case Types.GET_GRUPO_FAMILIAR_RESPONSE: {
        draft.success = true;
        draft.grupoFamiliar = action.payload.response;
        break;
      }
      case Types.GET_LISTA_INATIVAS_REQUEST: {
        draft.loading = true;
        draft.create = false;
        draft.success = false;
        draft.isError = false;
        draft.error = false;
        draft.details = false;
        draft.response = [];

        break;
      }
      case Types.GET_LISTA_INATIVAS_RESPONSE: {
        draft.loading = false;
        draft.success = true;
        draft.loadFamiliar = true;
        draft.isError = action.payload.isError;
        draft.response = action.payload.response;
        break;
      }
      case Types.GET_LISTAS_ERROR: {
        draft.getListas.loading = false;
        draft.getListas.error = action.payload.error;
        break;
      }
      case Types.GET_LISTAS_POR_STATUS_REQUEST: {
        draft.getListas.loading = true;
        break;
      }
      case Types.GET_LISTAS_POR_STATUS_SUCCESS: {
        draft.getListas.loading = false;
        setTabContentPorStatusSingleObj(
          action.payload.response,
          StatusListaAPIEnum.returnTabForName,
          draft.getListas.response
        );

        draft.getListas.success = action.payload.success;
        break;
      }
      case Types.GET_LISTAS_POR_STATUS_ERROR: {
        draft.getListas.loading = false;
        draft.getListas.error = action.payload.error;
        break;
      }
      case Types.POST_ARQUIVO_IMPORTACAO_REQUEST: {
        draft.postArquivoImportacao.loading = true;
        draft.postArquivoImportacao.success = false;
        draft.postArquivoImportacao.response = [];
        draft.postArquivoImportacao.isError = false;
        break;
      }
      case Types.POST_ARQUIVO_IMPORTACAO_SUCCESS: {
        draft.postImportarLote.files = draft.postImportarLote.files.map(
          (file) => {
            if (file.idLista === action.payload.files.idLista)
              file.name = action.payload.files.name;
            file.base64 = action.payload.files.base64;

            return file;
          }
        );
        draft.postArquivoImportacao.success = true;
        draft.postArquivoImportacao.loading = false;
        break;
      }
      case Types.POST_ARQUIVO_IMPORTACAO_ERROR: {
        draft.loading = false;
        draft.error = action.payload.error;
        break;
      }
      case Types.POST_IMPORTAR_LOTE_CSV_REQUEST: {
        draft.postImportarLoteCsv.loading = true;
        break;
      }
      case Types.POST_IMPORTAR_LOTE_CSV_SUCCESS: {
        draft.postImportarLoteCsv.loading = false;
        draft.postImportarLoteCsv.success = action.payload.isSuccess;
        break;
      }
      case Types.POST_VALIDAR_LOTE_CSV_REQUEST: {
        draft.postImportarLote.loading = true;
        draft.postImportarLote.files = action.payload.params.newFiles;
        draft.postImportarLote.tipoMovimentacao =
          action.payload.params.TipoLista;
        draft.postImportarLote.success = false;
        draft.postImportarLote.isError = false;
        draft.postImportarLote.error = '';
        break;
      }
      case Types.IMPORTAR_LOTE_REQUEST: {
        draft.postImportarLote.loading = true;
        draft.postImportarLote.files = action.payload.params.newFiles;
        draft.postImportarLote.tipoMovimentacao =
          action.payload.params.TipoLista;
        draft.postImportarLote.success = false;
        draft.postImportarLote.isError = false;
        draft.postImportarLote.error = '';
        break;
      }
      case Types.IMPORTAR_LOTE_RENEW: {
        draft.postImportarLote.loading = false;
        draft.postImportarLote.files = [];
        draft.postImportarLote.success = false;
        draft.postImportarLote.isError = false;
        draft.postImportarLote.error = '';
        break;
      }
      case Types.IMPORTAR_LOTE_UPDATE: {
        draft.postImportarLote.files = draft.postImportarLote.files.map(
          (file) => {
            if (
              file.idFile === action.payload.files.idFile &&
              action.payload.files
            )
              file = action.payload.files;

            return file;
          }
        );

        break;
      }
      case Types.IMPORTAR_LOTE_UPDATE_PROGRESS: {
        const fileAtual = draft.postImportarLote.files.find(
          (file) =>
            file.idLista?.toString() === action.payload.idLista ||
            file.idFile?.toString() === action.payload.idLista
        );
        if (fileAtual) {
          fileAtual.progress = action.payload.progress;
        }
        break;
      }
      case Types.IMPORTAR_LOTE_UPDATE_STATUS: {
        const fileAtual = draft.postImportarLote.files.find(
          (file) => file.idFile === action.payload.idFile
        );

        if (fileAtual) {
          fileAtual.error = action.payload.error;
          fileAtual.uploaded = action.payload.uploaded;
        }
        break;
      }
      case Types.IMPORTAR_LOTE_UPDATE_FILES: {
        draft.postImportarLote.files = draft.postImportarLote.files.filter(
          (file) => file.error !== true
        );

        break;
      }
      case Types.IMPORTAR_LOTE_SUCCESS: {
        draft.postImportarLote.loading = false;
        draft.postImportarLote.success = action.payload.isSuccess;
        draft.postImportarLote.isPartialSuccess =
          action.payload.isPartialSuccess;
        draft.postImportarLote.isError = false;
        draft.postImportarLote.error = '';
        break;
      }
      case Types.IMPORTAR_LOTE_LOG_ERROR: {
        draft.postImportarLote.loading = false;
        draft.postImportarLote.logError.push({
          hasError: true,
          fileName: action.payload.filename,
          base64: action.payload.base64,
        });
        break;
      }
      case Types.IMPORTAR_LOTE_LOG_ERROR_RENEW: {
        draft.postImportarLote.logError = [];
        break;
      }
      case Types.IMPORTAR_LOTE_ERROR: {
        draft.postImportarLote.loading = false;
        draft.postImportarLote.success = false;
        draft.postImportarLote.isError = action.payload.isError;
        draft.postImportarLote.error = action.payload.error;
        break;
      }
      case Types.PUT_LISTAS_REQUEST: {
        draft.putListas.loading = true;
        draft.putListas.response = [];
        draft.putListas.success = false;
        draft.putListas.isError = false;
        break;
      }
      case Types.PUT_LISTAS_RENEW: {
        draft.putListas.loading = false;
        draft.putListas.response = [];
        draft.putListas.success = false;
        draft.putListas.isError = false;
        break;
      }
      case Types.PUT_LISTAS_SUCCESS: {
        draft.putListas.loading = false;
        draft.putListas.success = action.payload.isSuccess;

        draft.postImportarLote.files = draft.postImportarLote.files.map(
          (file) => {
            const newFile = action.payload.newListas.find(
              (newLista) =>
                newLista.idLista === file.idLista &&
                newLista.descricao !== file.descricao
            );
            if (newFile) file = newFile;

            return file;
          }
        );
        break;
      }
      case Types.PUT_LISTAS_ERROR: {
        draft.putListas.loading = false;
        draft.putListas.isError = true;
        draft.putListas.success = false;
        break;
      }
      case Types.PATCH_LISTA_STATUS_REQUEST: {
        draft.patchListaStatus.loading = true;
        draft.patchListaStatus.response = [];
        draft.patchListaStatus.success = false;
        draft.patchListaStatus.isError = false;
        break;
      }
      case Types.PATCH_LISTA_STATUS_RENEW: {
        draft.patchListaStatus.loading = false;
        draft.patchListaStatus.response = [];
        draft.patchListaStatus.success = false;
        draft.patchListaStatus.isError = false;
        break;
      }
      case Types.PACTH_LISTA_STATUS_SUCCESS: {
        draft.patchListaStatus.success = action.payload.isSuccess;
        draft.patchListaStatus.loading = false;
        draft.patchListaStatus.isError = false;
        break;
      }
      case Types.PATCH_LISTA_STATUS_ERROR: {
        draft.patchListaStatus.success = false;
        draft.patchListaStatus.loading = false;
        draft.patchListaStatus.isError = true;
        break;
      }
      case Types.DELETE_LISTA_REQUEST: {
        draft.deleteLista.loading = true;
        draft.deleteLista.success = false;
        draft.deleteLista.error = '';
        draft.deleteLista.isError = false;

        break;
      }
      case Types.DELETE_LISTA_SUCCESS: {
        draft.deleteLista.loading = false;
        draft.deleteLista.success = true;
        draft.postImportarLote.files = getDifferenceBetween(
          draft.postImportarLote.files,
          'idFile',
          action.payload.files,
          'idFile'
        );
        draft.postImportarLote.logError = getDifferenceBetween(
          draft.postImportarLote.logError,
          'filename',
          action.payload.files,
          'name'
        );
        break;
      }
      case Types.DELETE_LISTA_RENEW: {
        draft.deleteLista.loading = false;
        draft.deleteLista.success = false;
        draft.deleteLista.error = '';
        draft.deleteLista.isError = false;
        break;
      }
      case Types.DELETE_LISTA_ERROR: {
        draft.deleteLista.loading = false;
        draft.deleteLista.error = action.payload.error;
        draft.deleteLista.isError = true;
        break;
      }
      case Types.PATCH_LISTA_ENVIO_RPA_REQUEST: {
        draft.patchListaEnvioRPA.loading = true;
        draft.patchListaEnvioRPA.success = false;
        draft.patchListaEnvioRPA.error = null;
        draft.patchListaEnvioRPA.isError = null;
        draft.patchListaEnvioRPA.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_LISTA_ENVIO_RPA_SUCCESS: {
        draft.patchListaEnvioRPA.loading = false;
        draft.patchListaEnvioRPA.success = action.payload.isSuccess;
        draft.patchListaEnvioRPA.response = action.payload.response;
        draft.patchListaEnvioRPA.isError = false;
        break;
      }
      case Types.PATCH_LISTA_ENVIO_RPA_ERROR: {
        draft.patchListaEnvioRPA.loading = false;
        draft.patchListaEnvioRPA.isError = true;
        draft.patchListaEnvioRPA.error = action.payload.error;
        draft.patchListaEnvioRPA.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_LISTA_ENVIO_RPA_RENEW: {
        draft.patchListaEnvioRPA.loading = false;
        draft.patchListaEnvioRPA.success = false;
        draft.patchListaEnvioRPA.error = null;
        draft.patchListaEnvioRPA.isError = null;
        draft.patchListaEnvioRPA.unsuccessResponse = null;
        break;
      }
      case Types.GET_LISTAS_RPA_REQUEST: {
        draft.getListasRPA.loading = true;
        break;
      }
      case Types.GET_LISTAS_RPA_SUCCESS: {
        draft.getListasRPA.loading = false;
        setTabContentPorStatus(
          action.payload.response,
          StatusListaRPAEnum.returnTabForName,
          draft.getListasRPA.response
        );

        draft.getListasRPA.success = action.payload.success;
        break;
      }
      case Types.GET_LISTAS_RPA_ERROR: {
        draft.getListasRPA.loading = false;
        draft.getListasRPA.error = action.payload.error;
        break;
      }
      case Types.GET_LISTAS_RPA_POR_STATUS_REQUEST: {
        draft.getListasRPA.loading = true;
        break;
      }
      case Types.GET_LISTAS_RPA_POR_STATUS_SUCCESS: {
        draft.getListasRPA.loading = false;
        setTabContentPorStatusSingleObj(
          action.payload.response,
          StatusListaRPAEnum.returnTabForName,
          draft.getListasRPA.response
        );

        draft.getListasRPA.success = action.payload.success;
        break;
      }
      case Types.GET_LISTAS_RPA_POR_STATUS_ERROR: {
        draft.getListasRPA.loading = false;
        draft.getListasRPA.error = action.payload.error;
        break;
      }
      case Types.PATCH_STATUS_RPA_REQUEST: {
        draft.patchStatusRPA.success = false;
        draft.patchStatusRPA.unsuccessResponse = [];
        draft.patchStatusRPA.loading = false;
        draft.patchStatusRPA.isError = false;
        draft.patchStatusRPA.error = [];
        break;
      }
      case Types.PATCH_STATUS_RPA_SUCCESS: {
        draft.patchStatusRPA.success = action.payload.isSuccess;
        draft.patchStatusRPA.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_STATUS_RPA_ERROR: {
        draft.patchStatusRPA.error = action.payload.error;
        draft.patchStatusRPA.isError = true;
        draft.patchStatusRPA.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_STATUS_RPA_RENEW: {
        draft.patchStatusRPA.success = false;
        draft.patchStatusRPA.unsuccessResponse = [];
        draft.patchStatusRPA.loading = false;
        draft.patchStatusRPA.isError = false;
        draft.patchStatusRPA.error = [];
        break;
      }
      case Types.GET_RELATORIO_RPA_REQUEST: {
        draft.getRelatorioRPA.loading = true;
        break;
      }
      case Types.GET_RELATORIO_RPA_SUCCESS: {
        draft.getRelatorioRPA.loading = false;
        draft.getRelatorioRPA.response = action.payload.response;
        draft.getRelatorioRPA.success = action.payload.success;
        break;
      }
      case Types.GET_RELATORIO_RPA_ERROR: {
        draft.getRelatorioRPA.loading = false;
        draft.getRelatorioRPA.isError = true;
        draft.getRelatorioRPA.error = action.payload.error;
        break;
      }
      case Types.GET_RELATORIO_RPA_RENEW: {
        draft.getRelatorioRPA.loading = false;
        draft.getRelatorioRPA.success = false;
        draft.getRelatorioRPA.response = {};
        draft.getRelatorioRPA.unsuccessResponse = [];
        draft.getRelatorioRPA.error = null;
        draft.getRelatorioRPA.isError = false;
        break;
      }
      case Types.GET_LISTA_DETALHE_REQUEST: {
        draft.getListaDetalhe.loading = true;
        break;
      }
      case Types.GET_LISTA_DETALHE_SUCCESS: {
        draft.getListaDetalhe.loading = false;
        draft.getListaDetalhe.response = action.payload.response;
        draft.getListaDetalhe.success = action.payload.success;
        break;
      }
      case Types.GET_LISTA_DETALHE_ERROR: {
        draft.getListaDetalhe.loading = false;
        draft.getListaDetalhe.isError = true;
        draft.getListaDetalhe.error = action.payload.error;
        break;
      }
      case Types.GET_LISTA_MASSA_INICIAL_REQUEST: {
        draft.getListaMassaInicial.loading = false;
        break;
      }
      case Types.GET_LISTA_MASSA_INICIAL_SUCCESS: {
        draft.getListaMassaInicial.loading = false;
        draft.getListaMassaInicial.success = true;
        setTabContentPorStatusSingleObj(
          { ...action.payload.response, status: 'Todas' },
          {
            Todas: 'Todas',
          },
          draft.getListaMassaInicial.response
        );
        break;
      }
      case Types.GET_LISTA_MASSA_INICIAL_ERROR: {
        draft.getListaMassaInicial.error = action.payload.error;
        break;
      }
      case Types.GET_ARQUIVO_MASSA_INICIAL_REQUEST: {
        draft.getArquivoMassaInicial.loading = false;
        break;
      }
      case Types.GET_ARQUIVO_MASSA_INICIAL_ERROR: {
        draft.getArquivoMassaInicial.error = action.payload.error;
        break;
      }
      case Types.GET_ARQUIVO_MASSA_INICIAL_SUCCESS: {
        draft.getArquivoMassaInicial.loading = false;
        draft.getArquivoMassaInicial.response = {
          ...action.payload.response,
          nomeArquivoDownload: action.payload.nomeArquivoDownload,
        };
        draft.getArquivoMassaInicial.success = true;
        break;
      }
      case Types.GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_REQUEST: {
        draft.getArquivoMassaInicial.loading = false;
        break;
      }
      case Types.GET_TERMO_RESPONSABILIDADEVO_MASSA_INICIAL_ERROR: {
        draft.getArquivoMassaInicial.error = action.payload.error;
        break;
      }
      case Types.GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_SUCCESS: {
        draft.getArquivoMassaInicial.loading = false;
        draft.getArquivoMassaInicial.response = {
          arquivo: action.payload.response.arquivoTermo,
          extensaoArquivo: '.pdf',
          nomeArquivoDownload: action.payload.nomeArquivoDownload,
        };
        draft.getArquivoMassaInicial.success = true;
        break;
      }
      case Types.POST_ARQUIVO_MASSA_INICIAL_REQUEST: {
        draft.MassaInicial.post.loading = true;
        draft.MassaInicial.post.success = false;
        draft.MassaInicial.patch.error = null;
        break;
      }
      case Types.POST_ARQUIVO_MASSA_INICIAL_SUCCESS: {
        draft.MassaInicial.post.loading = false;
        draft.MassaInicial.post.success = true;
        draft.MassaInicial.post.idLista =
          action.payload.response.idListaMassaInicial;
        break;
      }
      case Types.POST_ARQUIVO_MASSA_INICIAL_ERROR: {
        draft.MassaInicial.post.loading = false;
        draft.MassaInicial.post.error = action.payload.error;
        break;
      }
      case Types.POST_ARQUIVO_MASSA_INICIAL_RENEW: {
        draft.MassaInicial.post.loading = true;
        draft.MassaInicial.post.success = false;
        draft.MassaInicial.post.error = null;
        break;
      }
      case Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_RENEW: {
        draft.MassaInicial.patch.loading = true;
        draft.MassaInicial.patch.success = false;
        draft.MassaInicial.patch.isError = false;
        break;
      }
      case Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_REQUEST: {
        draft.MassaInicial.patch.loading = true;
        draft.MassaInicial.patch.success = false;
        draft.MassaInicial.patch.isError = false;
        break;
      }
      case Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_ERROR: {
        draft.MassaInicial.patch.loading = false;
        draft.MassaInicial.patch.isError = true;
        draft.MassaInicial.patch.error = action.payload.error;
        break;
      }
      case Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_SUCCESS: {
        draft.MassaInicial.patch.loading = false;
        draft.MassaInicial.patch.success = true;
        break;
      }
      case Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_REQUEST: {
        draft.patchValidacaoListaTransferencia.loading = true;
        draft.patchValidacaoListaTransferencia.success = false;
        draft.patchValidacaoListaTransferencia.error = null;
        draft.patchValidacaoListaTransferencia.isError = null;
        draft.patchValidacaoListaTransferencia.unsuccessResponse = null;
        break;
      }
      case Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_SUCCESS: {
        draft.patchValidacaoListaTransferencia.loading = false;
        draft.patchValidacaoListaTransferencia.success =
          action.payload.isSuccess;
        draft.patchValidacaoListaTransferencia.response =
          action.payload.response;
        draft.patchValidacaoListaTransferencia.isError = false;
        break;
      }
      case Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_ERROR: {
        draft.patchValidacaoListaTransferencia.loading = false;
        draft.patchValidacaoListaTransferencia.isError = true;
        draft.patchValidacaoListaTransferencia.error = action.payload.error;
        draft.patchValidacaoListaTransferencia.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_RENEW: {
        draft.patchValidacaoListaTransferencia.loading = false;
        draft.patchValidacaoListaTransferencia.isError = false;
        draft.patchValidacaoListaTransferencia.success = false;
        draft.patchValidacaoListaTransferencia.error = {};
        draft.patchValidacaoListaTransferencia.unsuccessResponse = [];
        break;
      }
      case Types.IMPORTAR_LOTE_NESTLE_REQUEST: {
        draft.postImportarLote.loading = true;
        draft.postImportarLote.files = action.payload.params.newFiles;
        draft.postImportarLote.success = false;
        draft.postImportarLote.isError = false;
        draft.postImportarLote.error = '';
        break;
      }
      default:
    }
  });
}

export const Creators = {
  deleteListaCsv: (params) => ({
    type: Types.DELETE_LISTA_CSV_REQUEST,
    payload: { params },
  }),
  getDownloadArquivoLoteOriginal: (params) => ({
    type: Types.GET_ARQUIVO_LOTE_ORIGINAL_REQUEST,
    payload: { params },
  }),
  getDownloadArquivoLoteOriginalSuccess: (response, success) => ({
    type: Types.GET_ARQUIVO_LOTE_ORIGINAL_SUCCESS,
    payload: { response, success },
  }),
  getDownloadArquivoLoteOriginalError: (error) => ({
    type: Types.GET_ARQUIVO_LOTE_ORIGINAL_ERROR,
    payload: { error },
  }),
  getDownloadArquivoLoteOriginalRenew: () => ({
    type: Types.GET_ARQUIVO_LOTE_ORIGINAL_RENEW,
    payload: {},
  }),
  postRelatorioResumidoNovoRequest: (params, tipoRelatorio) => ({
    type: Types.POST_RELATORIO_RESUMIDO_NOVO_REQUEST,
    payload: { params, tipoRelatorio },
  }),
  postRelatorioResumidoNovoSuccess: (response, success) => ({
    type: Types.POST_RELATORIO_RESUMIDO_NOVO_SUCCESS,
    payload: { response, success },
  }),
  postRelatorioResumidoNovoError: (error) => ({
    type: Types.POST_RELATORIO_RESUMIDO_NOVO_ERROR,
    payload: { error },
  }),
  postRelatorioResumidoNovoRenew: () => ({
    type: Types.POST_RELATORIO_RESUMIDO_NOVO_RENEW,
    payload: {},
  }),
  postRelatorioDetalhadoNovoRequest: (params, tipoRelatorio) => ({
    type: Types.POST_RELATORIO_DETALHADO_NOVO_REQUEST,
    payload: { params, tipoRelatorio },
  }),
  postRelatorioDetalhadoNovoSuccess: (response, success) => ({
    type: Types.POST_RELATORIO_DETALHADO_NOVO_SUCCESS,
    payload: { response, success },
  }),
  postRelatorioDetalhadoNovoError: (error) => ({
    type: Types.POST_RELATORIO_DETALHADO_NOVO_ERROR,
    payload: { error },
  }),
  postRelatorioDetalhadoNovoRenew: () => ({
    type: Types.POST_RELATORIO_DETALHADO_NOVO_RENEW,
    payload: {},
  }),
  postSearchListRpaRequest: (params) => ({
    type: Types.POST_SEARCH_LIST_RPA_REQUEST,
    payload: { params },
  }),
  postSearchListRpaResponse: (response, success) => ({
    type: Types.POST_SEARCH_LIST_RPA_RESPONSE,
    payload: { response, success },
  }),
  postSearchListRequest: (params) => ({
    type: Types.POST_SEARCH_LIST_REQUEST,
    payload: { params },
  }),
  postSearchListResponse: (response, success) => ({
    type: Types.POST_SEARCH_LIST_RESPONSE,
    payload: { response, success },
  }),
  getStatusListRpaRequest: () => ({
    type: Types.GET_STATUS_LIST_RPA_REQUEST,
  }),
  getStatusListRpaResponse: (response, success) => ({
    type: Types.GET_STATUS_LIST_RPA_RESPONSE,
    payload: { response, success },
  }),
  getStatusListContratanteRequest: (idContrantante, mostrarListaFake) => ({
    type: Types.GET_STATUS_LIST_CONTRATANTE_REQUEST,
    payload: { idContrantante, mostrarListaFake },
  }),
  getStatusListContratanteResponse: (response, success) => ({
    type: Types.GET_STATUS_LIST_CONTRATANTE_RESPONSE,
    payload: { response, success },
  }),
  getStatusListAdminRequest: () => ({
    type: Types.GET_STATUS_LIST_ADMIN_REQUEST,
    payload: {},
  }),
  getStatusListAdminResponse: (response, success) => ({
    type: Types.GET_STATUS_LIST_ADMIN_RESPONSE,
    payload: { response, success },
  }),
  getStatusListNestleRequest: (mostrarListaFake) => ({
    type: Types.GET_STATUS_LIST_NESTLE_REQUEST,
    payload: { mostrarListaFake },
  }),
  getStatusListNestleResponse: (response, success) => ({
    type: Types.GET_STATUS_LIST_NESTLE_RESPONSE,
    payload: { response, success },
  }),
  getListasRequest: (params, TipoStatus) => ({
    type: Types.GET_LISTAS_REQUEST,
    payload: { params, TipoStatus },
  }),
  getListasSuccess: (response, success) => ({
    type: Types.GET_LISTAS_SUCCESS,
    payload: { response, success },
  }),
  getListasError: (error) => ({
    type: Types.GET_LISTAS_ERROR,
    payload: { error },
  }),
  postListaInativasRequest: (contratante) => ({
    type: Types.POST_LISTA_INATIVAS_REQUEST,
    payload: { contratante },
  }),
  postListaInativasSuccess: (response, success) => ({
    type: Types.POST_LISTA_INATIVAS_RESPONSE,
    payload: { response, success },
  }),
  putListaInativasRequest: (params) => ({
    type: Types.PUT_LISTA_INATIVAS_REQUEST,
    payload: { params },
  }),
  putListaInativasSuccess: (response, success) => ({
    type: Types.PUT_LISTA_INATIVAS_RESPONSE,
    payload: { response, success },
  }),
  getListaInativasRequest: (idLista) => ({
    type: Types.GET_LISTA_INATIVAS_REQUEST,
    payload: { idLista },
  }),
  getListaGrupoFamiliarRequest: (id) => ({
    type: Types.GET_GRUPO_FAMILIAR_REQUEST,
    payload: { id },
  }),
  getListaGrupoFamiliarSuccess: (response, success) => ({
    type: Types.GET_GRUPO_FAMILIAR_RESPONSE,
    payload: { response, success },
  }),
  getListaInativasSuccess: (response, success) => ({
    type: Types.GET_LISTA_INATIVAS_RESPONSE,
    payload: { response, success },
  }),
  getListaBeneficiarioRequest: (params) => ({
    type: Types.GET_LISTA_BENEFICIARIOS_REQUEST,
    payload: { params },
  }),
  getListaBeneficiarioRenew: (params) => ({
    type: Types.GET_LISTA_BENEFICIARIOS_RENEW,
    payload: { params },
  }),
  postSalvarBeneficiarioInativosRequest: (params) => ({
    type: Types.POST_SALVAR_BENEFICIARIO_INATIVOS_REQUEST,
    payload: { params },
  }),
  setFamiliar: (param) => ({
    type: Types.SET_LISTA_FAMILIAR_REQUEST,
    payload: { param },
  }),
  postFamiliarRequest: (idLista, beneficiarios) => ({
    type: Types.POST_LISTA_FAMILIAR_REQUEST,
    payload: { idLista, beneficiarios },
  }),
  postFamiliarResponse: (response, success, error = null) => ({
    type: Types.POST_LISTA_FAMILIAR_RESPONSE,
    payload: { response, success, error },
  }),
  postSalvarBeneficiarioInativosSuccess: (response, success) => ({
    type: Types.POST_SALVAR_BENEFICIARIO_INATIVOS_SUCCESS,
    payload: { response, success },
  }),
  postSalvarBeneficiarioInativosError: (error) => ({
    type: Types.POST_SALVAR_BENEFICIARIO_INATIVOS_ERROR,
    payload: { error },
  }),
  getListaBeneficiarioSuccess: (response, success) => ({
    type: Types.GET_LISTA_BENEFICIARIOS_RESPONSE,
    payload: { response, success },
  }),
  getListasPorStatusRequest: (params, cpf) => ({
    type: Types.GET_LISTAS_POR_STATUS_REQUEST,
    payload: { params, cpf },
  }),
  getListasPorStatusSuccess: (response, success) => ({
    type: Types.GET_LISTAS_POR_STATUS_SUCCESS,
    payload: { response, success },
  }),
  getListasPorStatusError: (error) => ({
    type: Types.GET_LISTAS_POR_STATUS_ERROR,
    payload: { error },
  }),
  postArquivoImportacaoRequest: (novoArquivoRequest) => ({
    type: Types.POST_ARQUIVO_IMPORTACAO_REQUEST,
    payload: { novoArquivoRequest },
  }),
  postArquivoImportacaoSuccess: (files) => ({
    type: Types.POST_ARQUIVO_IMPORTACAO_SUCCESS,
    payload: { files },
  }),
  postArquivoImportacaoError: (error) => ({
    type: Types.POST_ARQUIVO_IMPORTACAO_ERROR,
    payload: { error },
  }),
  importarLoteRequest: (params) => ({
    type: Types.IMPORTAR_LOTE_REQUEST,
    payload: { params },
  }),
  importarLoteCsvRequest: (params) => ({
    type: Types.POST_IMPORTAR_LOTE_CSV_REQUEST,
    payload: { params },
  }),
  importarLoteCsvSuccess: (isSuccess) => ({
    type: Types.POST_IMPORTAR_LOTE_CSV_SUCCESS,
    payload: { isSuccess },
  }),
  validarLoteCsvRequest: (params) => ({
    type: Types.POST_VALIDAR_LOTE_CSV_REQUEST,
    payload: { params },
  }),
  importarLoteSuccess: (isSuccess, isPartialSuccess) => ({
    type: Types.IMPORTAR_LOTE_SUCCESS,
    payload: { isSuccess, isPartialSuccess },
  }),
  importarLoteLogError: (filename, base64) => ({
    type: Types.IMPORTAR_LOTE_LOG_ERROR,
    payload: { filename, base64 },
  }),
  importarLoteLogErrorRenew: () => ({
    type: Types.IMPORTAR_LOTE_LOG_ERROR_RENEW,
    payload: {},
  }),
  importarLoteRenew: () => ({
    type: Types.IMPORTAR_LOTE_RENEW,
  }),
  importarLoteUpdate: (files) => ({
    type: Types.IMPORTAR_LOTE_UPDATE,
    payload: { files },
  }),
  importarLoteUpdateProgress: (idLista, progress) => ({
    type: Types.IMPORTAR_LOTE_UPDATE_PROGRESS,
    payload: { idLista, progress },
  }),
  importarLoteUpdateStatus: (idFile, error, uploaded) => ({
    type: Types.IMPORTAR_LOTE_UPDATE_STATUS,
    payload: { idFile, error, uploaded },
  }),
  importarLoteUpdateFiles: () => ({
    type: Types.IMPORTAR_LOTE_UPDATE_FILES,
  }),
  importarLoteError: (error, isError) => ({
    type: Types.IMPORTAR_LOTE_ERROR,
    payload: { error, isError },
  }),
  putListasRequest: (listas) => ({
    type: Types.PUT_LISTAS_REQUEST,
    payload: { listas },
  }),
  putListasRenew: () => ({
    type: Types.PUT_LISTAS_RENEW,
  }),
  putListasSuccess: (newListas, isSuccess) => ({
    type: Types.PUT_LISTAS_SUCCESS,
    payload: { newListas, isSuccess },
  }),
  putListasError: (error) => ({
    type: Types.PUT_LISTAS_ERROR,
    payload: { error },
  }),
  patchListaStatusRequest: (listas) => ({
    type: Types.PATCH_LISTA_STATUS_REQUEST,
    payload: { listas },
  }),
  patchListaStatusRenew: () => ({
    type: Types.PATCH_LISTA_STATUS_RENEW,
  }),
  patchListaStatusSuccess: (isSuccess) => ({
    type: Types.PACTH_LISTA_STATUS_SUCCESS,
    payload: { isSuccess },
  }),
  patchListaStatusError: (error) => ({
    type: Types.PATCH_LISTA_STATUS_ERROR,
    payload: { error },
  }),
  deleteListaRequest: (listas) => ({
    type: Types.DELETE_LISTA_REQUEST,
    payload: { listas },
  }),
  deleteListaSuccess: (success, files) => ({
    type: Types.DELETE_LISTA_SUCCESS,
    payload: { success, files },
  }),
  deleteListaRenew: () => ({
    type: Types.DELETE_LISTA_RENEW,
  }),
  deleteListaError: (error) => ({
    type: Types.DELETE_LISTA_ERROR,
    payload: { error },
  }),
  patchListaEnvioRPARequest: (listas, isActive) => ({
    type: Types.PATCH_LISTA_ENVIO_RPA_REQUEST,
    payload: { listas, isActive },
  }),
  patchListaEnvioRPASuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_LISTA_ENVIO_RPA_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchListaEnvioRPAError: (error) => ({
    type: Types.PATCH_LISTA_ENVIO_RPA_ERROR,
    payload: { error },
  }),
  patchListaEnvioRPARenew: () => ({
    type: Types.PATCH_LISTA_ENVIO_RPA_RENEW,
  }),
  getListasRPARequest: (params, TipoStatus) => ({
    type: Types.GET_LISTAS_RPA_REQUEST,
    payload: { params, TipoStatus },
  }),
  getListasRPASuccess: (response, success) => ({
    type: Types.GET_LISTAS_RPA_SUCCESS,
    payload: { response, success },
  }),
  getListasRPAError: (error) => ({
    type: Types.GET_LISTAS_RPA_ERROR,
    payload: { error },
  }),
  getListasRPAPorStatusRequest: (params) => ({
    type: Types.GET_LISTAS_RPA_POR_STATUS_REQUEST,
    payload: { params },
  }),
  getListasRPAPorStatusSuccess: (response, success) => ({
    type: Types.GET_LISTAS_RPA_POR_STATUS_SUCCESS,
    payload: { response, success },
  }),
  getListasRPAPorStatusError: (error) => ({
    type: Types.GET_LISTAS_RPA_POR_STATUS_ERROR,
    payload: { error },
  }),
  patchStatusRPARequest: (listas, tipoStatus) => ({
    type: Types.PATCH_STATUS_RPA_REQUEST,
    payload: { listas, tipoStatus },
  }),
  patchStatusRPASuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_STATUS_RPA_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchStatusRPAError: (error) => ({
    type: Types.PATCH_STATUS_RPA_ERROR,
    payload: { error },
  }),
  patchStatusRPARenew: () => ({
    type: Types.PATCH_STATUS_RPA_RENEW,
  }),
  getRelatorioRPARequest: (params, tipoRelatorio) => ({
    type: Types.GET_RELATORIO_RPA_REQUEST,
    payload: { params, tipoRelatorio },
  }),
  getRelatorioRPASuccess: (response, success) => ({
    type: Types.GET_RELATORIO_RPA_SUCCESS,
    payload: { response, success },
  }),
  getRelatorioRPAError: (error) => ({
    type: Types.GET_RELATORIO_RPA_ERROR,
    payload: { error },
  }),
  getRelatorioRPARenew: () => ({
    type: Types.GET_RELATORIO_RPA_RENEW,
    payload: {},
  }),
  getListaDetalheRequest: (idLista) => ({
    type: Types.GET_LISTA_DETALHE_REQUEST,
    payload: { idLista },
  }),
  getListaDetalheSuccess: (response, success) => ({
    type: Types.GET_LISTA_DETALHE_SUCCESS,
    payload: { response, success },
  }),
  getListaDetalheError: (error) => ({
    type: Types.GET_LISTA_DETALHE_ERROR,
    payload: { error },
  }),
  getListasMassaInicialRequest: (params) => ({
    type: Types.GET_LISTA_MASSA_INICIAL_REQUEST,
    payload: { params },
  }),
  getListasMassaInicialError: (error) => ({
    type: Types.GET_LISTA_MASSA_INICIAL_ERROR,
    payload: { error },
  }),
  getListasMassaInicialSuccess: (response) => ({
    type: Types.GET_LISTA_MASSA_INICIAL_SUCCESS,
    payload: { response },
  }),
  getArquivoMassaInicialRequest: (idLista, idArquivo, nomeArquivoDownload) => ({
    type: Types.GET_ARQUIVO_MASSA_INICIAL_REQUEST,
    payload: { idLista, idArquivo, nomeArquivoDownload },
  }),
  getArquivoMassaInicialError: (error) => ({
    type: Types.GET_ARQUIVO_MASSA_INICIAL_ERROR,
    payload: { error },
  }),
  getArquivoMassaInicialSuccess: (response, nomeArquivoDownload) => ({
    type: Types.GET_ARQUIVO_MASSA_INICIAL_SUCCESS,
    payload: { response, nomeArquivoDownload },
  }),
  postArquivoMassaInicialRequest: (body) => ({
    type: Types.POST_ARQUIVO_MASSA_INICIAL_REQUEST,
    payload: { body },
  }),
  postArquivoMassaInicialRenew: () => ({
    type: Types.POST_ARQUIVO_MASSA_INICIAL_RENEW,
    payload: {},
  }),
  postArquivoMassaInicialSuccess: (response) => ({
    type: Types.POST_ARQUIVO_MASSA_INICIAL_SUCCESS,
    payload: { response },
  }),
  postArquivoMassaInicialError: (error) => ({
    type: Types.POST_ARQUIVO_MASSA_INICIAL_ERROR,
    payload: { error },
  }),
  getTermoResponsabilidadeMassaInicialRequest: (
    idLista,
    nomeArquivoDownload
  ) => ({
    type: Types.GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_REQUEST,
    payload: { idLista, nomeArquivoDownload },
  }),
  getTermoResponsabilidadeMassaInicialError: (error) => ({
    type: Types.GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_ERROR,
    payload: { error },
  }),
  getTermoResponsabilidadeMassaInicialSuccess: (
    response,
    nomeArquivoDownload
  ) => ({
    type: Types.GET_TERMO_RESPONSABILIDADE_MASSA_INICIAL_SUCCESS,
    payload: { response, nomeArquivoDownload },
  }),
  patchValidacaoListaTrasnferenciaRequest: (listas) => ({
    type: Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_REQUEST,
    payload: { listas },
  }),
  patchValidacaoListaTrasnferenciaSuccess: (unsuccessResponse, isSuccess) => ({
    type: Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_SUCCESS,
    payload: { unsuccessResponse, isSuccess },
  }),
  patchValidacaoListaTrasnferenciaError: (error) => ({
    type: Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_ERROR,
    payload: { error },
  }),
  patchValidacaoListaTrasnferenciaRenew: () => ({
    type: Types.PATCH_VALIDACAO_LISTA_TRASNFERENCIA_RENEW,
  }),
  patchAceiteCompartilhamentoMassaInicialRequest: (idLista, body) => ({
    type: Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_REQUEST,
    payload: { idLista, body },
  }),
  patchAceiteCompartilhamentoMassaInicialError: (error) => ({
    type: Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_ERROR,
    payload: { error },
  }),
  patchAceiteCompartilhamentoMassaInicialSuccess: () => ({
    type: Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_SUCCESS,
    payload: {},
  }),
  patchAceiteCompartilhamentoMassaInicialRenew: () => ({
    type: Types.PATCH_ACEITE_COMPARTILHAMENTO_MASSA_INICIAL_RENEW,
    payload: {},
  }),
  postArquivoImportacaoNestleRequest: (params) => ({
    type: Types.IMPORTAR_LOTE_NESTLE_REQUEST,
    payload: { params },
  }),
  checkBenefiarioInativos: (idBeneficiario) => ({
    type: Types.CHECK_BENEFICIARIO_INATIVOS,
    payload: { idBeneficiario },
  }),
};
